// src/views/ForgotPassword.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState('email');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Email is required');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      setIsLoading(false);
      if (data.success) {
        setSuccess('Password reset code sent to your email.');
        setError('');
        setStep('reset');
      } else {
        setError(data.message || 'Failed to process request');
        setSuccess('');
      }
    } catch (error) {
      setIsLoading(false);
      setError('Failed to connect to server');
      setSuccess('');
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    if (!code || !newPassword) {
      setError('Code and new password are required');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, newPassword }),
      });
      const data = await response.json();
      setIsLoading(false);
      if (data.success) {
        setSuccess('Password reset successfully. Please log in.');
        setError('');
        setTimeout(() => navigate('/'), 2000);
      } else {
        setError(data.message || 'Failed to reset password');
        setSuccess('');
      }
    } catch (error) {
      setIsLoading(false);
      setError('Failed to connect to server');
      setSuccess('');
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card card">
        <img src={`${(import.meta.env.DEV ? '/' : (import.meta.env.VITE_ASSET_BASE || import.meta.env.BASE_URL || '/'))}companyweblogo.png`} alt="Easy3PL Logo" className="forgot-password-logo" />
        {error && <span className="error-message">{error}</span>}
        {success && <span className="success-message">{success}</span>}
        {step === 'email' ? (
          <form onSubmit={handleEmailSubmit}>
            <div className="input-group">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className={`input ${error ? 'input-error' : ''}`}
              />
              {error && <span className="error-message">{error}</span>}
            </div>
            <button type="submit" className="forgot-password-button button">
              Send Reset Instructions
            </button>
          </form>
        ) : (
          <form onSubmit={handleResetSubmit}>
            <div className="input-group">
              <input
                type="text"
                id="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter reset code"
                className={`input ${error ? 'input-error' : ''}`}
              />
              {error && <span className="error-message">{error}</span>}
            </div>
            <div className="input-group">
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                className={`input ${error ? 'input-error' : ''}`}
              />
            </div>
            <button type="submit" className="forgot-password-button button">
              Reset Password
            </button>
          </form>
        )}
        <div className="back-to-login">
          <a href="/" className="back-to-login-link link">
            Back to Login
          </a>
        </div>
      </div>
      {isLoading && (
        <div className="loading-modal">
          <div className="loading-content">
            <span className="loading-icon"></span>
            <span>Sending you instructions to reset your password, please wait...</span>
          </div>
        </div>
      )}

      {/* End content */}
    </div>
  );
};

export default ForgotPassword;
